import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=c547d4c2&scoped=true"
var script = {}
import style0 from "./NavBar.vue?vue&type=style&index=0&id=c547d4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c547d4c2",
  null
  
)

export default component.exports